/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusArticleDto } from './NovitusArticleDto';
import {
    NovitusArticleDtoFromJSON,
    NovitusArticleDtoFromJSONTyped,
    NovitusArticleDtoToJSON,
} from './NovitusArticleDto';
import type { NovitusAdvanceDto } from './NovitusAdvanceDto';
import {
    NovitusAdvanceDtoFromJSON,
    NovitusAdvanceDtoFromJSONTyped,
    NovitusAdvanceDtoToJSON,
} from './NovitusAdvanceDto';

/**
 * 
 * @export
 * @interface NovitusItemDto
 */
export interface NovitusItemDto {
    /**
     * Szczegóły artykułu/towaru
     * @type {NovitusArticleDto}
     * @memberof NovitusItemDto
     */
    article: NovitusArticleDto;
    /**
     * Szczegóły zaliczki
     * @type {NovitusAdvanceDto}
     * @memberof NovitusItemDto
     */
    advance: NovitusAdvanceDto;
    /**
     * Szczegóły zwrotu zaliczki
     * @type {NovitusAdvanceDto}
     * @memberof NovitusItemDto
     */
    advance_return: NovitusAdvanceDto;
}

/**
 * Check if a given object implements the NovitusItemDto interface.
 */
export function instanceOfNovitusItemDto(value: object): value is NovitusItemDto {
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('advance' in value) || value['advance'] === undefined) return false;
    if (!('advance_return' in value) || value['advance_return'] === undefined) return false;
    return true;
}

export function NovitusItemDtoFromJSON(json: any): NovitusItemDto {
    return NovitusItemDtoFromJSONTyped(json, false);
}

export function NovitusItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'article': NovitusArticleDtoFromJSON(json['article']),
        'advance': NovitusAdvanceDtoFromJSON(json['advance']),
        'advance_return': NovitusAdvanceDtoFromJSON(json['advance_return']),
    };
}

export function NovitusItemDtoToJSON(value?: NovitusItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'article': NovitusArticleDtoToJSON(value['article']),
        'advance': NovitusAdvanceDtoToJSON(value['advance']),
        'advance_return': NovitusAdvanceDtoToJSON(value['advance_return']),
    };
}

